<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :show-close-button="false"
    :show-title="true"
    :width="'75%'"
    :height="155"
    :title="popupConfig.title"
    :wrapper-attr="{
      class:
        'css-v2 gc-popup gc-popup-form gc-popup-process-shift-recurring-deduction',
    }"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
  >
    <DxToolbarItem
      v-if="popupConfig.formMode !== 'create' && popupConfig.secondaryTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${popupConfig.secondaryTitle}</span>`"
    ></DxToolbarItem>

    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
      :template="item.template ? item.template : null"
    />

    <div class="css-v2 gc-popup-data-grid">
      <dx-data-grid
        @toolbar-preparing="onToolbarPreparing($event)"
        :key="popupConfig.formKey"
        :data-source="getDataSource"
        :columns="getColumns"
        :show-borders="false"
        :height="74"
        :row-alternation-enabled="true"
        :columnChooser="{
          enabled: false,
        }"
        :pager="{ visible: false }"
        :column-auto-width="false"
        :ref="'shifts-tab-grid-downtime'"
        @row-removed="onRowRemoved"
        :keyExpr="'id'"
      >
        <DxEditing
          :allow-deleting="false"
          :allow-updating="popupConfig.formMode !== 'review'"
          :mode="'cell'"
          :confirm-delete="false"
        />

        <template #timeEditorTemplate="{ data }">
          <DxTextBox
            :value="minutesTo24Hour(data.value)"
            mask="00:00"
            :mask-rules="{ '0': /[0-9]/ }"
            @value-changed="(e) => onTimeChanged(e.value, data)"
            @focus-in="(e) => e.event.target.select()"
          />
        </template>
      </dx-data-grid>
    </div>

    <DxLoadPanel
      :position="{ of: '#container-wrapper' }"
      :visible.sync="loadingVisible"
      :show-indicator="true"
      :show-pane="true"
      :shading="true"
      :hide-on-outside-click="false"
      shading-color="rgba(0,0,0,0)"
    />
  </DxPopup>
</template>
<script>
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { mapGetters } from "vuex";
import ArrayStore from "devextreme/data/array_store";
import { minutesTo24Hour } from "../../_helpers/ui/helpers";

const baseLine = {
  PlanningDeductionMinutesMonday: 0,
  PlanningDeductionMinutesTuesday: 0,
  PlanningDeductionMinutesWednesday: 0,
  PlanningDeductionMinutesThursday: 0,
  PlanningDeductionMinutesFriday: 0,
  PlanningDeductionMinutesSaturday: 0,
  PlanningDeductionMinutesSunday: 0,
};

export default {
  mixins: [DataGridMixin],
  components: {},
  data() {
    return {
      IsFormLoaded: false,
      isValid: false,
      loadingVisible: false,
      DeductionDataSource: new ArrayStore({
        key: "id",
        data: [],
      }),
    };
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {
        return {
          isPopupShow: false,
          formMode: "create",
          formKey: 1,
          secondaryTitle: "",
        };
      },
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    onHide: {
      type: Function,
      default: () => {},
    },
  },
  async created() {},
  methods: {
    /* Popup Events */
    onShown() {
      this.DeductionDataSource.clear();
      if (this.popupConfig.formMode === "create") {
        if (this.popupConfig.dataModel) {
          this.setDeductionData(this.popupConfig.dataModel);
        }
      } else {
        // TO DO: Review & Edit
        if (this.popupConfig.dataModel) {
          this.setDeductionData(this.popupConfig.dataModel);
        }
      }

      if (this.popupConfig.formMode !== "review") {
        setTimeout(() => {
          // let entry = { ...baseLine };
          // this.DeductionDataSource.insert({ ...entry });
          this.$nextTick(() => {
            this.focusOnEditableGridCell("PlanningDeductionMinutesMonday");
          });
        }, 100);
      }

      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
    },

    setDeductionData(data) {
      const entry = {
        PlanningDeductionMinutesMonday:
          data.PlanningDeductionMinutesMonday || 0,
        PlanningDeductionMinutesTuesday:
          data.PlanningDeductionMinutesTuesday || 0,
        PlanningDeductionMinutesWednesday:
          data.PlanningDeductionMinutesWednesday || 0,
        PlanningDeductionMinutesThursday:
          data.PlanningDeductionMinutesThursday || 0,
        PlanningDeductionMinutesFriday:
          data.PlanningDeductionMinutesFriday || 0,
        PlanningDeductionMinutesSaturday:
          data.PlanningDeductionMinutesSaturday || 0,
        PlanningDeductionMinutesSunday:
          data.PlanningDeductionMinutesSunday || 0,
      };

      this.DeductionDataSource.insert({ ...entry });
    },

    /*
    Popup Hide Event
    */
    onPopupHide(repaint = true) {
      this.$emit("setIsVisible", false);

      this.DeductionDataSource.clear();

      this.onHide(repaint);
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },

    /**
     * Popup Initialized Event
     * @param e
     */
    onInitialized(e) {
      this.IsFormLoaded = true;
      e.component.registerKeyHandler("escape", (arg) => {
        arg.stopPropagation();

        this.$nextTick(() => {
          this.onCancelPopupHandler();
        });
      });
    },

    /**
     * Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      if (this.popupConfig.formMode === "review") {
        this.onPopupHide(false);
        return;
      }
      if (this.popupConfig.isPopupShow) {
        const confirm = await this.$confirm(
          `You have unsaved changes. Are you sure you want to leave?`,
          "Unsaved changes",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          },
        );
        if (confirm) {
          this.onPopupHide();
        }
      }
    },

    async focusOutFromEditableCells() {
      var dataGrid = this.dataGrid;
      const activeElement = document.activeElement;
      if (activeElement) {
        activeElement.blur();
        if (dataGrid) dataGrid.saveEditData();
      }
    },

    async onSavePopupHandler() {
      await this.focusOutFromEditableCells();
      const getRowsWithPlanningDeductions = (rows) => {
        return rows.filter((row) =>
          Object.keys(row).some(
            (key) => key.startsWith("PlanningDeductionMinutes") && row[key] > 0,
          ),
        );
      };

      const items = await this.DeductionDataSource.load();
      // check if there is at least one entry with valid inputs
      const validItems = getRowsWithPlanningDeductions(items);

      if (validItems.length > 0) {
        this.$emit("onSaveRecurringDeduction", validItems);
      } else {
        // Validation removed, now user can save with zero deductions for all days if they wish to clear existing deductions
        // If no valid entries, emit an empty array or handle as needed

        // this.$alert(
        //   "Please enter deduction minutes for at least one day of the week.",
        //   "Validation Error",
        // );

        this.$emit("onSaveRecurringDeduction", [
          {
            PlanningDeductionMinutesMonday: 0,
            PlanningDeductionMinutesTuesday: 0,
            PlanningDeductionMinutesWednesday: 0,
            PlanningDeductionMinutesThursday: 0,
            PlanningDeductionMinutesFriday: 0,
            PlanningDeductionMinutesSaturday: 0,
            PlanningDeductionMinutesSunday: 0,
          },
        ]);
      }
    },

    onEditPopupHandler() {
      this.popupConfig.title = "Edit Schedule Note";
      this.popupConfig.formMode = "edit";
      this.popupConfig.formKey++;
      this.$nextTick(() => {
        // let dataField = "ProcessCode";
        // setTimeout(() => this.setFocusOnField(dataField), 700);
      });
    },

    /**
     * on so list grid toolbar preparing
     * @param e - event
     */
    onToolbarPreparing(e) {
      e.toolbarOptions.visible = false;
    },

    addNewRow() {
      this.DeductionDataSource.insert({ ...baseLine });
    },

    calculateDurationInMinutes(startTime, endTime) {
      if (!startTime || !endTime) return null;

      // Normalize both to the SAME day (1970-01-01)
      const normalizedStart = new Date(
        1970,
        0,
        1,
        startTime.getHours(),
        startTime.getMinutes(),
      );
      let normalizedEnd = new Date(
        1970,
        0,
        1,
        endTime.getHours(),
        endTime.getMinutes(),
      );

      let duration = (normalizedEnd - normalizedStart) / (1000 * 60);

      // SAME TIME = FULL 24 HOURS
      if (duration === 0) {
        duration = 24 * 60;
      }
      // Handle overnight shift (end past midnight)
      else if (duration < 0) {
        duration += 24 * 60;
      }

      return Math.ceil(duration);
    },

    async onRowRemoved(e) {
      if (!e) return;
      let items = await this.DeductionDataSource.load();
      if (items.length === 0) {
        this.addNewRow();
      } else if (items[items.length - 1].Description !== null) {
        this.addNewRow();
      }
    },

    onRowUpdated(e) {
      if (!e || !e.data) return;

      // check if this the last row then add new row
      const rowIndex = this.dataGrid.getRowIndexByKey(e.data.id);
      if (rowIndex === this.dataGrid.totalCount() - 1) {
        this.addNewRow();
      }
    },

    focusOnEditableGridCell(dataField, rowData = null) {
      if (this.dataGrid) {
        const dataGrid = this.dataGrid;
        let rowIndex = 0;
        if (rowData) {
          rowIndex = dataGrid.getRowIndexByKey(rowData.id);
        }
        if (rowIndex === -1) return;
        const cellElement = dataGrid.getCellElement(rowIndex, dataField);
        dataGrid.focus(cellElement);
        setTimeout(() => {
          dataGrid.editCell(rowIndex, dataField);
        }, 10);
      }
    },

    onTimeChanged(value, cellInfo) {
      cellInfo.setValue(this.timeStringToMinutes(value));
    },

    minutesTo24Hour(mins) {
      if (!mins || mins <= 0) return "00:00";
      const h = String(Math.floor(mins / 60)).padStart(2, "0");
      const m = String(mins % 60).padStart(2, "0");
      return `${h}:${m}`;
    },

    timeStringToMinutes(value) {
      if (!value) return 0;

      const digits = value.replace(/\D/g, "");

      let hours = 0;
      let minutes = 0;

      if (digits.length <= 2) {
        // "1" or "01" → hours only
        hours = Number(digits);
      } else if (digits.length === 3) {
        // "130" → 1:30
        hours = Number(digits.slice(0, 1));
        minutes = Number(digits.slice(1));
      } else {
        // "0130", "2359"
        hours = Number(digits.slice(0, 2));
        minutes = Number(digits.slice(2, 4));
      }

      // Clamp minutes safely
      if (minutes > 59) minutes = 59;

      return hours * 60 + minutes;
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },

    /**
     * Get Toolbar Items
     */
    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            text: "Save",
            stylingMode: "contained",
            type: "default",
            onClick: this.onSavePopupHandler,
            visible: this.popupConfig.formMode !== "review",
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          options: {
            icon: "close",
            onClick: this.onCancelPopupHandler,
          },
        },
      ];
    },

    getColumns() {
      return [
        {
          caption: "Mon",
          dataField: "PlanningDeductionMinutesMonday",
          dataType: "number",
          cssClass: "edit-cell-textbox-field first-editable-column",
          calculateDisplayValue: (rowData) =>
            minutesTo24Hour(rowData.PlanningDeductionMinutesMonday),
          setCellValue: (newData, value) => {
            newData.PlanningDeductionMinutesMonday = value;
            return newData;
          },
          editCellTemplate: "timeEditorTemplate",
          alignment: "left",
        },
        {
          caption: "Tue",
          dataField: "PlanningDeductionMinutesTuesday",
          dataType: "number",
          cssClass: "edit-cell-textbox-field",
          calculateDisplayValue: (rowData) =>
            minutesTo24Hour(rowData.PlanningDeductionMinutesTuesday),
          setCellValue: (newData, value) => {
            newData.PlanningDeductionMinutesTuesday = value;
            return newData;
          },
          editCellTemplate: "timeEditorTemplate",
          alignment: "left",
        },
        {
          caption: "Wed",
          dataField: "PlanningDeductionMinutesWednesday",
          dataType: "number",
          cssClass: "edit-cell-textbox-field",
          calculateDisplayValue: (rowData) =>
            minutesTo24Hour(rowData.PlanningDeductionMinutesWednesday),
          setCellValue: (newData, value) => {
            newData.PlanningDeductionMinutesWednesday = value;
            return newData;
          },
          editCellTemplate: "timeEditorTemplate",
          alignment: "left",
        },
        {
          caption: "Thu",
          dataField: "PlanningDeductionMinutesThursday",
          dataType: "number",
          cssClass: "edit-cell-textbox-field",
          calculateDisplayValue: (rowData) =>
            minutesTo24Hour(rowData.PlanningDeductionMinutesThursday),
          setCellValue: (newData, value) => {
            newData.PlanningDeductionMinutesThursday = value;
            return newData;
          },
          editCellTemplate: "timeEditorTemplate",
          alignment: "left",
        },
        {
          caption: "Fri",
          dataField: "PlanningDeductionMinutesFriday",
          dataType: "number",
          cssClass: "edit-cell-textbox-field",
          calculateDisplayValue: (rowData) =>
            minutesTo24Hour(rowData.PlanningDeductionMinutesFriday),
          setCellValue: (newData, value) => {
            newData.PlanningDeductionMinutesFriday = value;
            return newData;
          },
          editCellTemplate: "timeEditorTemplate",
          alignment: "left",
        },
        {
          caption: "Sat",
          dataField: "PlanningDeductionMinutesSaturday",
          dataType: "number",
          cssClass: "edit-cell-textbox-field",
          calculateDisplayValue: (rowData) =>
            minutesTo24Hour(rowData.PlanningDeductionMinutesSaturday),
          setCellValue: (newData, value) => {
            newData.PlanningDeductionMinutesSaturday = value;
            return newData;
          },
          editCellTemplate: "timeEditorTemplate",
          alignment: "left",
        },
        {
          caption: "Sun",
          dataField: "PlanningDeductionMinutesSunday",
          dataType: "number",
          cssClass: "edit-cell-textbox-field",
          calculateDisplayValue: (rowData) =>
            minutesTo24Hour(rowData.PlanningDeductionMinutesSunday),
          setCellValue: (newData, value) => {
            newData.PlanningDeductionMinutesSunday = value;
            return newData;
          },
          editCellTemplate: "timeEditorTemplate",
          alignment: "left",
        },
        // {
        //   dataField: "",
        //   caption: "",
        //   type: "buttons",
        //   buttons: [
        //     {
        //       hint: "Delete",
        //       icon: "trash",
        //       visible: this.popupConfig.formMode !== "review",
        //       onClick: async (e) => {
        //         const confirmDelete = await this.$confirm(
        //           "Are you sure you want to delete this entry?",
        //           "Delete Entry",
        //         );
        //         if (confirmDelete) {
        //           this.dataGrid.deleteRow(e.row.rowIndex);
        //         }
        //       },
        //     },
        //   ],
        //   visible: this.popupConfig.formMode !== "review",
        //   width: 50,
        //   minWidth: 50,
        // },
      ];
    },

    getDataSource() {
      return this.DeductionDataSource._array;
    },
    dataGrid() {
      if (this.$refs["shifts-tab-grid-downtime"]) {
        return this.$refs["shifts-tab-grid-downtime"].instance;
      } else {
        return null;
      }
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val && this.getVisible) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          this.onSavePopupHandler();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-process-shift-recurring-deduction {
  .dx-toolbar.dx-popup-title {
    height: 60px;
  }

  .toolbar-title-secondary {
    padding-left: unset !important;
    font-weight: 400;
    font-size: 14px;
  }

  .dx-datagrid-header-panel {
    height: 0px !important;
  }

  .dx-datagrid .dx-datagrid-content {
    .dx-datagrid-table .dx-row .dx-editor-cell:not(.first-editable-column) {
      padding-right: 5px !important;
      padding-left: 5px !important;
    }

    .dx-datebox {
      .dx-placeholder::before {
        padding-left: unset !important;
        padding-bottom: unset !important;
        padding-top: unset !important;
      }
    }
  }

  .edit-cell-textbox-field {
    .dx-placeholder::before {
      padding-left: 0 !important;
      padding-bottom: 2px !important;
    }
  }

  .edit-cell-numberbox-field {
    .dx-numberbox.dx-texteditor:not(.dx-state-readonly)::after {
      content: "";
      border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
    }
    .dx-numberbox.dx-texteditor.dx-state-readonly {
      border-bottom-style: dotted !important;
      border-bottom-width: 1px !important;
    }
  }

  .dx-scrollable-container {
    overflow: hidden !important;
  }
}
</style>
